// Author thq
// Date 2021-12-15 09:18:40

class EmSicBoardLifeCycleSdl {
constructor({
        id = null,
        sdlName = '',
        sdlComeuse = '',
        sdlLivetime = '',
        sdlSeq = '',
        sdlEnableState = '',
        remark = ''}
= {}) {
    this.id = id;
    this.sdlName = sdlName;
    this.sdlComeuse = sdlComeuse;
    this.sdlLivetime = sdlLivetime;
    this.sdlSeq = sdlSeq;
    this.sdlEnableState = sdlEnableState;
    this.remark = remark;
}
}

function newEntity() {
return new EmSicBoardLifeCycleSdl();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.statusCollection.emSicBoardLifeCycleSdl.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdlName',
        label: 'label.em.statusCollection.emSicBoardLifeCycleSdl.grid.sdlName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdlComeuse',
        label: 'label.em.statusCollection.emSicBoardLifeCycleSdl.grid.sdlComeuse',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdlLivetime',
        label: 'label.em.statusCollection.emSicBoardLifeCycleSdl.grid.sdlLivetime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdlLifePrcent',
        label: 'label.em.statusCollection.emSicBoardLifeCycleSdl.grid.sdlLifePrcent',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdlSeq',
        label: 'label.em.statusCollection.emSicBoardLifeCycleSdl.grid.sdlSeq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdlEnableState',
        label: 'label.em.statusCollection.emSicBoardLifeCycleSdl.grid.sdlEnableState',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '0', text: '停用' },
                            { value: '1', text: '启用' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.emSicBoardLifeCycleSdl.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    sdlNameFilter : "",
    sdlComeuseRteFilter : "",
    sdlComeuseLteFilter : "",
    sdlLivetimeFilter : "",
    sdlEnableStateFilter : "",
    sdlSeqFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'sdlNameFilter',
        label: 'label.em.statusCollection.emSicBoardLifeCycleSdl.filter.sdlName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sdlComeuseRteFilter',
        label: 'label.em.statusCollection.emSicBoardLifeCycleSdl.filter.sdlComeuseRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'sdlComeuseLteFilter',
        label: 'label.em.statusCollection.emSicBoardLifeCycleSdl.filter.sdlComeuseLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'sdlEnableStateFilter',
        label: 'label.em.statusCollection.emSicBoardLifeCycleSdl.filter.sdlEnableState',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '0', text: '停用' },
                { value: '1', text: '启用' }
            ]
        }
        },
];


    const entityFormConfigs = [
        {
        key: 'sdlName',
        label: 'label.em.statusCollection.emSicBoardLifeCycleSdl.entity.sdlName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sdlComeuse',
        label: 'label.em.statusCollection.emSicBoardLifeCycleSdl.entity.sdlComeuse',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'sdlLivetime',
        label: 'label.em.statusCollection.emSicBoardLifeCycleSdl.entity.sdlLivetime',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'sdlSeq',
        label: 'label.em.statusCollection.emSicBoardLifeCycleSdl.entity.sdlSeq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'sdlEnableState',
        label: 'label.em.statusCollection.emSicBoardLifeCycleSdl.entity.sdlEnableState',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '0', text: '停用' },
                { value: '1', text: '启用' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.emSicBoardLifeCycleSdl.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmSicBoardLifeCycleSdl, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
